import { BaseController } from "../../../common/base/controller";

export default class AddSecuritiesController extends BaseController {
	info = {};
	messages = {};

	constructor(controllerService, addSecuritiesService, $scope) {
		"ngInject";
		super({
			controllerService,
			addSecuritiesService,
			$scope,
		});
	}

	$onInit() {
		this.fields = [
			{
				name: "name",
				showInfo: false,
				type: "text",
				required: true,
			},
			{
				name: "isin",
				showInfo: true,
				type: "text",
				required: true,
			},
			{
				name: "quantity",
				showInfo: true,
				type: "number",
				required: true,
			},
		];

		this.security = this.addSecuritiesService.initEmptySecurity();

		this.fields.forEach((field) => {
			this.messages[field.name] = {
				required: `app.addSecurities.input.${field.name}.required`,
			};
		});
	}

	close() {
		this.modalInstance.close(this.security);
	}

	dismiss() {
		this.modalInstance.dismiss();
	}

	isInvalid() {
		return this.form.$invalid;
	}
}



// WEBPACK FOOTER //
// ./src/app/common/ui/addSecurities/addSecurities.controller.js